<template>
  <div class="message_view"
       v-loading="loading">
    <div class="message_view_top">
      <div class="top_title">
        <span>消息</span>
      </div>
      <div class="top_control">
        <el-link type="primary"
                 @click="allRead">全部已读</el-link>
        <el-link type="primary"
                 @click="skipAllMore">查看更多</el-link>
      </div>
    </div>
    <div class="message_view_content">
      <div class="content_item"
           v-for="(item,index) in orderList"
           :key='index'
           @click="skipClick(item)">
        <div class="sign"
             v-if="item.is_read==0"></div>
        <div class="item_top">
          <div>来自：{{item.type|showTextView}}</div>
          <div>{{item.create_time}}</div>
        </div>
        <div class="item_content"
             v-html="item.message">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
import { postMessage, allRead } from '../request/api'
export default {
  name: 'message_view',
  data () {
    return {
      // -----------加载动画-----------
      loading: false,
      // -----------通知数组-----------
      orderList: [],
      // -----------合计数量-----------
      totalNum: 0,
      // -----------页码-----------
      page: 1,

    }
  },
  filters: {
    // type：1订单通知，2系统通知，3用户通知，4，其他

    showTextView (e) {
      if (e == 1) {
        return '订单通知'
      } else if (e == 2) {
        return '系统通知'
      } else if (e == 3) {
        return '用户通知'
      } else if (e == 4) {
        return '其他'
      }
      return ''
    },
  },
  methods: {
    // -----------跳转页面-----------
    skipClick (row) {
      if (row.is_read == 0) {
        this.setRead(true, row.id)
      }
      if (row.sign) {
        if (row.type == 1) {
          this.$router.replace({
            name: 'allOrders',
            query: {
              id: row.sign
            }
          })
          this.$router.go(0)

        } else if (row.type == 3) {
          this.$router.push({
            name: 'Userinfo'
          })
        }
      }

    },
    // -----------跳转查看所有信息-----------
    skipAllMore () {
      this.$router.push({
        name: 'messageList'
      })
    },
    // -----------设置已读-----------
    async setRead (id) {
      let res = await allRead({
        id
      })
      if (res.errno == 0) {
        this.$message.success(id !== '' ? '已读成功' : '信息全部已读成功')
        this.gettMessage()
      } else {
        this.$message.error(res.message)
      }
    },
    // -----------全部已读-----------
    async allRead () {
      this.$confirm('把所有消息设置为已读, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setRead()
      }).catch(() => {

      });
    },
    // -----------获取信息列表-----------
    async gettMessage () {
      this.loading = true
      let res = await postMessage({
        module_name: 'wxl_oms',
        page: this.page,
        pagesize: 10
      })
      if (res.tzlist) {
        this.totalNum = res.totalNum
        this.orderList = res.tzlist
        for (const key in this.orderList) {
          this.orderList[key].create_time = common.formatDate(this.orderList[key].create_time)
        }
      } else {
        this.totalNum = 0
        this.orderList = []
      }
      this.loading = false
    },
  },
  created () {
    this.gettMessage()
  },

}
</script>

<style lang='scss'>
.message_view {
  color: #333;
  position: absolute;
  left: -230px;
  width: 300px;
  height: 420px;
  top: 48px;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 999;
  .sign {
    width: 5px;
    height: 5px;
    background-color: red;
    position: absolute;
    right: 0;
    top: -5px;
    border-radius: 50%;
  }
  .message_view_content {
    flex: 1;
    height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 5px;
    box-sizing: border-box;
    .content_item:hover {
      .item_content {
        color: #409eff;
      }
      .item_top {
        color: #409eff;
      }
    }
    .content_item {
      width: 100%;
      min-height: 70px;
      // background-color: pink;
      margin-bottom: 6px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      position: relative;
      padding: 5px 0;
      .item_content {
        font-size: 12px;
        padding: 5px 0;
        color: #333;
      }

      .item_top {
        display: flex;
        height: 20px;
        font-size: 12px;
        align-items: center;
        justify-content: space-between;
        // font-size: ;
        color: #999;
      }
    }
  }
  .message_view_top {
    flex: 1;

    width: 100%;
    max-height: 50px;
    min-height: 50px;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
    align-items: center;
    border-bottom: 1px solid #eee;
    // background-color: #333;

    .top_title {
      color: #999;
    }
    .el-link {
      margin-left: 10px;
      font-size: 12px;
    }
  }
}
</style>